import PropTypes from 'prop-types';

import Container from '../../Container';
import RichText from '../../RichText';
import CtaButtonLink from '../../CtaButtonLink';
import CtaTextLink from '../../CtaTextLink';
import Modal from '../../Modal';

import { Banner, CtaContainer } from './styles';

const HeroBannerText = ({ data, themes }) => {
  const {
    isTransparent,
    showDivider,
    marginType,
    headingRTF,
    subheadingRTF,
    ctaLinks,
  } = data;
  const hasHeading = headingRTF && headingRTF;
  const hasSubheading = subheadingRTF && subheadingRTF;

  return (
    (hasHeading || hasSubheading) && (
      <Banner
        isTransparent={isTransparent}
        subHeading={hasSubheading}
        showDivider={showDivider}
        className={marginType}
      >
        <Container>
          {hasHeading && <RichText document={headingRTF} />}
          {hasSubheading && <RichText document={subheadingRTF} />}
          {ctaLinks && (
            <CtaContainer>
              {ctaLinks.map((cta) => {
                const {
                  __typename,
                  linkType,
                  style,
                  linkUrlMarkdown,
                  linkTextMarkdown,
                  linkText,
                  ariaLabel,
                  id,
                } = cta;
                if (__typename === 'ContentfulModal')
                  return <Modal key={id} data={cta} themes={themes} />;
                if (linkType === 'Button' || linkType === 'button')
                  return (
                    <CtaButtonLink
                      key={id}
                      contentId={id}
                      variant={style}
                      url={linkUrlMarkdown.linkUrlMarkdown}
                      ariaLabel={ariaLabel}
                    >
                      {linkText || linkTextMarkdown.linkTextMarkdown}
                    </CtaButtonLink>
                  );
                if (linkType === 'Text-Link')
                  return (
                    <CtaTextLink
                      key={id}
                      contentId={id}
                      variant={style}
                      url={linkUrlMarkdown.linkUrlMarkdown}
                      ariaLabel={ariaLabel}
                      themes={themes}
                    >
                      {linkText || linkTextMarkdown.linkTextMarkdown}
                    </CtaTextLink>
                  );
                return null;
              })}
            </CtaContainer>
          )}
        </Container>
      </Banner>
    )
  );
};

HeroBannerText.propTypes = {
  data: PropTypes.shape().isRequired,
  themes: PropTypes.string.isRequired,
};

export default HeroBannerText;
